import axios from "axios";
import logo from "../assets/logo.png";
import { IoClose } from "react-icons/io5";
import { useState } from "react";
import { baseUrl } from "../config";

const LoginForm = ({ setLogin }) => {
    const [formData, setFormData] = useState({
        username: "",
        phoneNumber: ""
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const cleanPhoneNumber = formData.phoneNumber.replace(/\D/g, '');
            const userId = `${formData.username}${cleanPhoneNumber}${Date.now()}`;
            const res = await axios.post(`${baseUrl}/register`, {
                id: userId,
                name: formData.username,
                phone: cleanPhoneNumber
            });

            const user = res.data;
            console.log("Registered:", user);
            localStorage.setItem("username", user.name);
            localStorage.setItem("phoneNumber", user.phone);
            localStorage.setItem("userId", user.id);

            setLogin(false);
        } catch (error) {
            console.error("Login error:", error);
            alert("Error connecting to server!");
        }
    };
    return (
        <div className='w-[90vw] h-[90vh] max-w-md max-h-[550px] min-h-[450px] bg-white rounded-lg sm:rounded-xl shadow-[0_0_20px_rgba(0,0,0,0.15)] p-3 xs:p-4 sm:p-5 relative flex flex-col'>
            <div className="flex items-center justify-between gap-3 border-b border-gray-200 pb-3 sm:pb-4 ">
                <div className="flex items-center gap-3">
                    <div className="w-8 h-8 xs:w-10 xs:h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center shadow-[0_0_8px_rgba(0,0,0,0.1)] p-1">
                        <img src={logo} alt="logo" className="h-3 xs:h-4 sm:h-5 w-auto" />
                    </div>
                    <div>
                        <p className="font-semibold text-sm xs:text-base sm:text-lg">PhoneKadai</p>
                        <p className="text-xs text-gray-500">Welcome back</p>
                    </div>
                </div>
                <button 
                    onClick={() => setLogin(false)} 
                    className='text-gray-500 hover:text-red-500 rounded-full p-1 hover:bg-gray-100 transition-colors duration-200'
                >
                    <IoClose className="text-current" size={20} />
                </button>
            </div>
            <div className="flex-1 flex flex-col justify-center">
                <div className="text-center mb-6 sm:mb-8">
                    <h2 className="text-xl xs:text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                        Log In
                    </h2>
                    <p className="text-gray-600 text-sm xs:text-base">
                        Access your PhoneKadai account
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4 xs:space-y-5 sm:space-y-6">
                    <div>
                        <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">
                            Username
                        </label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            value={formData.username}
                           onChange={(e) => setFormData({...formData, username: e.target.value})}
                            required
                            className="w-full px-3 xs:px-4 py-2 xs:py-3 border border-gray-300 rounded-lg sm:rounded-xl focus:outline-none focus:ring-2 focus:ring-[#42C8B7] focus:border-transparent transition-all duration-200 text-sm xs:text-base"
                            placeholder="Enter your username"
                            minLength={3}
                            maxLength={20}
                        />
                    </div>
                    <div>
                        <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700 mb-2">
                            Phone Number
                        </label>
                        <div className="relative">
                            <input
                                type="tel"
                                id="phoneNumber"
                                name="phoneNumber"
                                value={formData.phoneNumber}
                                onChange={(e) => setFormData({...formData, phoneNumber: e.target.value})}
                                required
                                className="w-full px-3 xs:px-4 py-2 xs:py-3 border border-gray-300 rounded-lg sm:rounded-xl focus:outline-none focus:ring-2 focus:ring-[#42C8B7] focus:border-transparent transition-all duration-200 text-sm xs:text-base"
                                placeholder="6373435363"
                                maxLength={12}
                            />
                            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                                <span className="text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded">
                                    IN
                                </span>
                            </div>
                        </div>
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-[#42C8B7] hover:bg-[#38b2a3] text-white py-2 xs:py-3 rounded-lg sm:rounded-xl font-medium transition-colors duration-200 flex items-center justify-center gap-2 text-sm xs:text-base"
                    >
                        Log In
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginForm;